__webpack_require__.p = "/angular12/referrals/";